import useOffersLoader from "../common/useOffersLoader";

const useShipmentSideEffects = (): void => {
  useOffersLoader();
};
export default useShipmentSideEffects;
